"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _UnmanagedDrawer = _interopRequireDefault(require("./UnmanagedDrawer"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Drawer = function Drawer(_ref) {
  var open = _ref.open,
      onHide = _ref.onHide,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["open", "onHide"]);
  return (0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
    onExitComplete: onHide,
    children: open && (0, _jsxRuntime.jsx)(_UnmanagedDrawer["default"], _objectSpread({}, restProps))
  });
};

Drawer.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,

  /**
   * Narrow: 440px; wide: 740px; wideXL: 960px
   */
  size: (0, _propTypes.oneOf)(['narrow', 'wide', 'wideXL']),
  className: _propTypes.string,
  footer: _propTypes.node.isRequired,
  title: _propTypes.string.isRequired,

  /**
   * If the drawer is open or not
   */
  open: _propTypes.bool,

  /**
   * Handle close drawer
   */
  onClose: _propTypes.func.isRequired,

  /**
   * Handle when the drawer changes from visible to invisible
   */
  onHide: _propTypes.func,

  /**
   * Whether the content (children) is in a loading state
   * children components will not be rendered if true
   */
  isLoading: _propTypes.bool,

  /**
   * Loading progress: 0 to 100
   */
  loadingProgress: _propTypes.number,

  /**
   * Whether the content (children) has an error
   * children components will not be rendered if true
   */
  isError: _propTypes.bool,

  /**
   * Whether the content (children) has an empty state (for example if a resource could not be found)
   * children components will not be rendered if true
   */
  isNoResultFound: _propTypes.bool,

  /**
   * The drawer body container
   */
  container: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),

  /**
   * Styles for inner content
   */
  contentStyles: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({
    name: _propTypes.string,
    styles: _propTypes.string
  }), _propTypes.func])
};
Drawer.defaultProps = {
  size: 'narrow',
  className: undefined,
  open: undefined,
  onHide: function onHide() {},
  isLoading: false,
  loadingProgress: undefined,
  isError: false,
  isNoResultFound: false,
  container: 'div',
  contentStyles: undefined
};
var _default = Drawer;
exports["default"] = _default;
//# sourceMappingURL=Drawer.js.map